import { makeRequest, buildResponse, buildError } from 'helpers/requestHandler'
export default class User {
  constructor(email, password) {
    this.email = email
    this.password = password
  }

  // **********************************
  // User Authentication & Registration
  // **********************************

  login() {
    return new Promise((resolve,reject) => {
      makeRequest('/users/login','POST',{
        'email' : this.email,
        'password': this.password
      }).then((response) => {
        if(response.ok){
          response.json().then((json) => {
            this.auth = {
              'key' : json.token,
              'validity' : json.validity
            }
            resolve(buildResponse(true, json))
          })
        } else {
          switch (response.status){
            case 403:
               reject(buildError(response, reject, 'Invalid credentials'))
              break
            default:
               reject(buildError(response, reject, 'Unknown'))
              break
          }
        }
      })
    })
  }

  logout(key) {
    return new Promise((resolve, reject) => {
      makeRequest('/users/logout','POST', {
        'key' : key
      }).then((response) => {
        if(response.ok) {
          resolve(buildResponse(true, null))
        } else {
          switch (response.status){
            case 403:
              return buildError(response, reject, 'Invalid authentication key')
            default:
              return buildError(response, reject, 'Unknown')
          }
        }
      })
    })
  }

  register(email, password, operatorID = null) {
    return new Promise((resolve, reject) => {
      makeRequest('/users/register','POST', {
        'email' : email,
        'password' : password,
        'operator_id' : operatorID
      }).then((response) => {
        if(response.ok){
          resolve(buildResponse(true, null))
        } else {
          switch (response.status){
            case 403:
              return buildError(response, reject, 'Not enough permissions to perform operation')
            default:
              return buildError(response, reject, 'Unknown')
          }
        }
      })
    })
  }

  view(email = null, key) {
    return new Promise((resolve,reject) => {
      makeRequest('/users/view','POST', {
        'key' : key,
        'email' : (email ? email : this.email)
      }).then((response) => {
        if(response.ok){
          response.json().then((json) => resolve(buildResponse(true, json)))
        } else {
          switch (response.status){
            case 403:
              return buildError(response, reject, 'Not enough permissions to perform operation')
            default:
              return buildError(response, reject, 'Unknown')
          }
        }
      })
    })
  }

  activate(email, key) {
    return new Promise((resolve, reject) => {
      makeRequest('/users/activate', 'POST', {
        'key' : key,
        'email' : email
      }).then((response) => {
        if(response.ok){
          resolve(buildResponse(true, null))
        } else {
          switch (response.status){
            case 403:
              return buildError(response, reject, 'Not enough permissions to perform operation')
            default:
              return buildError(response, reject, 'Unknown')
          }
        }
      })
    })
  }

  deactivate(email, key) {
    return new Promise((resolve, reject) => {
      makeRequest('/users/deactivate', 'POST', {
        'key' : key,
        'email' : email
      }).then((response) => {
        if(response.ok){
          resolve(buildResponse(true, null))
        } else {
          switch (response.status){
            case 403:
              return buildError(response, reject, 'Not enough permissions to perform operation')
            default:
              return buildError(response, reject, 'Unknown')
          }
        }
      })
    })
  }

  edit(email, data, key) {
    return new Promise((resolve, reject) => {
      let body = {
        'key' : key,
        'email' : email
      }
      for (const key of Object.keys(data)) {
        body[(key == 'email' ? 'new_' + key : key)] = data[key]
      }
      makeRequest('/users/edit', 'POST', body).then((response) => {
        if(response.ok){
          resolve(buildResponse(true, null))
        } else {
          switch (response.status){
            case 403:
              return buildError(response, reject, 'Not enough permissions to perform operation')
            default:
              return buildError(response, reject, 'Unknown')
          }
        }
      })
    })
  }

  resetPassword(email, code = null, password = null) {
    return ((code || password) == null ?
      new Promise((resolve, reject) => {
        makeRequest('/users/reset', 'POST',{
          'email' : email,
          'callback' : window.location.origin + '/user/reset-password/'
        }).then((response) => {
          if(response.ok){
            resolve(buildResponse(true, null))
          } else {
            switch (response.status){
              case 404:
                return buildError(response, reject, 'User does not exist')
              default:
                return buildError(response, reject, 'Unknown')
            }
          }
        })
      })
      :
      new Promise((resolve, reject) => {
        makeRequest('/users/reset', 'POST',{
          'email' : email,
          'code' : code,
          'password' : password
        }).then((response) => {
          if(response.ok){
            resolve(buildResponse(true, null))
          } else {
            switch (response.status){
              case 404:
                return buildError(response, reject, 'User does not exist')
              default:
                return buildError(response, reject, 'Unknown')
            }
          }
        })
      })
    )
  }
}


// WEBPACK FOOTER //
// ./src/thunks/classes/User.js